import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import NumbersCallPlanForm from './NumbersCallPlanForm'
import { changeCallPlan } from '../Numbers.actions'

const formName = 'numbersCallPlanForm'

const stateToProps = ({ form }) => ({
  form: formName,
  formData: get(form, `${formName}.values`, {}),
})

const dispatchToProps = {
  changeCallPlan,
}

export default connect(stateToProps, dispatchToProps)(reduxForm()(NumbersCallPlanForm))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersCallPlanForm/NumbersCallPlanForm.container.js